import { CoreDomainSearchStore } from '@wix/domains-search-suite';
import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { useCallback } from 'react';
import { TLD_PREFILL_QUERY_PARAM } from '../constants';
import { DomainSearchGateModule } from '../module/domainSearchGate.module';
import { buildDomainFromSiteName, isDefaultSiteName } from '../utils/siteName';
import { tldClickSearchService } from './tldClickSearchService';
import { useIsGateTldChipsEnabled } from './useIsGateTldChipsEnabled';
import { useTldPress } from './useTldPress';
import { useViewTransition } from './useViewTransition';
export const useOpenTldResults = () => {
  const {
    navigateTo
  } = useViewTransition();
  const showTldChips = useIsGateTldChipsEnabled();
  const press = useTldPress(true);
  return useCallback((tld, cardBi) => {
    if (showTldChips) {
      press(tld, cardBi);
      return;
    }
    const {
      siteName
    } = getPremiumEssentialsSafe() ?? {};
    const domain = buildDomainFromSiteName(siteName, tld);
    const searchSiteNameWithTld = !isDefaultSiteName(siteName) && !!domain;
    DomainSearchGateModule.internals.bi.onGateTldClick == null || DomainSearchGateModule.internals.bi.onGateTldClick({
      ...cardBi,
      tld,
      domain: searchSiteNameWithTld ? domain : undefined,
      isSearchExecuted: searchSiteNameWithTld
    });
    if (!searchSiteNameWithTld) {
      navigateTo(`/results?${TLD_PREFILL_QUERY_PARAM}=${encodeURIComponent(tld)}`);
      return;
    }
    tldClickSearchService.mark(domain);
    CoreDomainSearchStore.setQuery(domain);
    CoreDomainSearchStore.setSubmittedDomain(domain);
    CoreDomainSearchStore.setSubmittedFilters({
      query: domain,
      tlds: [],
      keywords: [],
      style: ''
    });
    navigateTo(`/results?q=${encodeURIComponent(domain)}`);
  }, [navigateTo, showTldChips, press]);
};
//# sourceMappingURL=useOpenTldResults.js.map